import { Modal } from '@postidigital/posti-components'
import { BrandTheme } from '@postidigital/posti-theme'
import styled, { css } from 'styled-components'

export const StyledModal = styled(Modal)`
  @media ${BrandTheme.breakpoint.md} {
    margin: 0;
  }

  @media ${BrandTheme.breakpoint.lg} {
    width: 38rem;
    max-width: 38rem;
  }
`

export const StyledDialog = styled(Modal.Dialog)(
  ({ theme: { spacing } }) => css`
    min-height: 100%;
    padding: ${spacing.space0}rem ${spacing.space5}rem ${spacing.space8}rem;
    overflow: auto;
  `
)
